var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDrawing(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 224,
    height: 160,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M155.159 25.938c-3.139-5.005-8.725-7.863-15.33-7.863a22.396 22.396 0 0 0-7.536 1.27 19.525 19.525 0 0 0-5.762-1.46 13.807 13.807 0 0 0-3.856-11.947 13.755 13.755 0 0 0-9.735-4.04 13.683 13.683 0 0 0-7.98 2.556 16.338 16.338 0 0 0-3.693-.424c-4.34 0-8.504 1.727-11.573 4.802A16.411 16.411 0 0 0 84.9 20.426v.106a22.268 22.268 0 0 0-9.98 11.076c-.165.393-.393.857-.64 1.412a59.082 59.082 0 0 0-3.646 9.53c-2.014 7.078-2.948 15.63-2.862 26.105 0 .15-.023.295-.027.444l-.577 18.614v.366a22.829 22.829 0 0 0 5.402 14.712 22.75 22.75 0 0 0 13.606 7.743v24.771a22.639 22.639 0 0 0 6.61 15.968 22.556 22.556 0 0 0 15.938 6.625 22.377 22.377 0 0 0 8.637-1.709 22.42 22.42 0 0 0 7.314-4.908 22.442 22.442 0 0 0 4.898-7.325 22.501 22.501 0 0 0 1.704-8.651v-24.771a22.757 22.757 0 0 0 13.614-7.737 22.824 22.824 0 0 0 5.409-14.714V70.31c.047-.491.064-.985.051-1.478-.088-2.799-.015-5.6.22-8.39.895-10.346 3.847-15.894 4.961-17.982.2-.393.393-.735.573-1.116a16.094 16.094 0 0 0-.946-15.406Z",
    fill: "#FF90E8",
    stroke: "#000",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M100.724 36.64c.094-.35 1.715-6.016 7.888-6.291 6.378-.28 6.998 6.31 6.998 6.31s1.818-6.601 9.106-6.314c7.065.28 5.848 5.965 5.774 6.291.149-.35 2.641-6.008 9.419-6.008 5.939 0 6.625 4.412 5.683 6.366-.784 1.62-5.428 8.984-6.672 23.198-5.918-7.655-13.176-4.018-24.448-2.87-11.272 1.148-12.257-4.97-20.664-9.559-8.242-4.51-11.524-1.273-11.645-1.151l-.157-.044c1.291-4.553 2.81-7.25 3.783-9.523 1.143-2.678 3.949-6.547 9.467-6.409 6.245.153 5.519 5.658 5.468 6.004Z",
    fill: "#000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m101.246 70.142-21.638.106h-.039l-.35 11.186-.227 7.424a10.968 10.968 0 0 0 3.205 7.746 10.929 10.929 0 0 0 7.734 3.208h4.2a3.878 3.878 0 0 1 3.59 2.4c.194.472.295.978.295 1.489v32.387a10.811 10.811 0 0 0 3.156 7.636 10.767 10.767 0 0 0 7.622 3.161 10.742 10.742 0 0 0 7.622-3.145 10.797 10.797 0 0 0 3.14-7.636v-32.387a3.875 3.875 0 0 1 .294-1.488 3.874 3.874 0 0 1 3.583-2.401h4.204a10.923 10.923 0 0 0 7.734-3.207 10.957 10.957 0 0 0 3.204-7.747V69.973m-.009-.013-36.368.174M79.56 81.443h58.453",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M108.788 140.293a4.015 4.015 0 0 0 4.011-4.019 4.015 4.015 0 0 0-4.011-4.018 4.015 4.015 0 0 0-4.012 4.018 4.015 4.015 0 0 0 4.012 4.019ZM130.465 36.66c.149-.35 2.641-6.008 9.42-6.008 5.938 0 6.625 4.412 5.683 6.366-.785 1.62-5.428 8.984-6.672 23.198a83.205 83.205 0 0 0-.259 9.76h-.079c-11.433 0-24.566.094-36.368.176h-.957c-8.266.055-15.83.106-21.638.106-.165-11.426.981-18.676 2.402-23.682 1.291-4.553 2.81-7.25 3.784-9.523 1.142-2.677 3.948-6.546 9.466-6.409 6.245.158 5.519 5.662 5.468 6.008",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M100.721 36.66a.064.064 0 0 1 0-.02c.095-.35 1.716-6.016 7.889-6.291 6.382-.28 7.002 6.31 7.002 6.31s1.818-6.601 9.106-6.314c7.065.28 5.848 5.965 5.773 6.291M82.158 46.62c.122-.122 3.403-3.358 11.645 1.152 8.407 4.593 9.361 10.715 20.633 9.567 11.272-1.148 18.529-4.785 24.448 2.87",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M94.185 69.986a85.39 85.39 0 0 1 4.243-28.054Z",
    fill: "#000"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M94.185 69.986a85.39 85.39 0 0 1 4.243-28.054",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M109.353 69.986a85.385 85.385 0 0 1 4.243-28.054Z",
    fill: "#000"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M109.353 69.986a85.385 85.385 0 0 1 4.243-28.054",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M101.77 69.986a85.385 85.385 0 0 1 4.243-28.054Z",
    fill: "#000"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M101.77 69.986a85.385 85.385 0 0 1 4.243-28.054",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M86.608 69.986a85.39 85.39 0 0 1 4.242-28.054Z",
    fill: "#000"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M86.608 69.986a85.39 85.39 0 0 1 4.242-28.054",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M124.52 69.986a85.33 85.33 0 0 1 4.239-28.054Z",
    fill: "#000"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M124.52 69.986a85.33 85.33 0 0 1 4.239-28.054",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.941 69.986a85.33 85.33 0 0 1 4.239-28.054Z",
    fill: "#000"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M116.941 69.986a85.33 85.33 0 0 1 4.239-28.054",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M132.096 69.986a85.278 85.278 0 0 1 4.243-28.054Z",
    fill: "#000"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M132.096 69.986a85.278 85.278 0 0 1 4.243-28.054",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M101.309 25.916a4.643 4.643 0 0 0 4.639-4.647 4.643 4.643 0 0 0-4.639-4.648 4.643 4.643 0 0 0-4.64 4.648 4.643 4.643 0 0 0 4.64 4.647Zm11.862-7.806c.988 0 1.789-.803 1.789-1.794 0-.99-.801-1.793-1.789-1.793-.989 0-1.79.803-1.79 1.793 0 .99.801 1.793 1.79 1.793Z",
    fill: "#000",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDrawing);
export default __webpack_public_path__ + "static/media/Drawing.bb0f58d75329c3b52b1f7db4e56fc486.svg";
export { ForwardRef as ReactComponent };